module.exports = {
  send_code_hint: 'Kami akan mengirimkan kode autentikasi ke nomor ini.',
  send_whatsapp: 'KIRIM WHATSAPP',
  do_you_have_username_password: 'Apakah Anda mempunyai username & kata sandi?',
  sigin_to_workspace: 'MASUK KE LINGKUNGAN KERJA',
  dont_have_account_pos: 'Tidak mempunyai akun di TokoPOS?',
  download_pos_from: 'Download TokoPOS melalui',
  send_auth_code_via: 'Kami akan mengirimkan kode autentikasi ke nomor',
  check_auth_code: 'Harap pastikan Anda memasukkan nomor handphone yang benar.',
  re_enter: 'Masukkan Ulang',
  continue: 'Lanjut',
  auth_code: 'Kode Autentikasi',
  auth_code_sent: 'Kode autentikasi sudah dikirimkan ke',
  check_auth_code_and_fill: 'Harap periksa dan isikan',
  enter_auth_code: 'Masukkan Kode Autentikasi',
  verify: 'VERIFIKASI',
  send_auth_after: 'Kirim kode autentikasi lagi dalam',
  resend_new_code: 'KIRIM KODE BARU',
  workspace: 'Lingkungan Kerja',
  password: 'Kata Sandi',
  workspace_login_incorrect: 'Lingkungan kerja, username, atau kata sandi salah.',
  please_enter_username: 'Harap masukkan username',
  please_enter_mobile_phone: 'Harap masukkan nomor handphone',
  please_enter_workspace: 'Harap masukkan lingkungan kerja',
  back_to_login_form: 'Kembali ke Halaman Login',
  sign_in_with_phone_number: 'MASUK DENGAN NOMOR HANDPHONE',
  confirm_mobile_number: 'Konfirmasi Nomor Handphone',
}
